import { useMemo } from "react"
import { addDays } from "src/shared/helpers/addDays"
import { useDate } from "src/shared/hooks/useDate"
import { useCosts } from "../context/CostContext"

const useDateRange = ({ startDate, daysCount }: { startDate: Date, daysCount: number }) => {
    const { setHHMMSS, } = useDate()
    const { tarifaBaseHabitacion } = useCosts()
    

    const settedStartDate = useMemo(() => setHHMMSS({ newHour: "00:00:00", startDate, isNewHourInUTC: false }), [startDate, daysCount])

    const settedEndDate = useMemo<Date>(() => addDays({ date: setHHMMSS({ newHour: tarifaBaseHabitacion?.hora_checkout || "00:00:00", startDate: settedStartDate, isNewHourInUTC: false }), days: daysCount }), [settedStartDate])



    return { startDate: settedStartDate, endDate: settedEndDate }

}

export default useDateRange